import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLimit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="limit"><path d="M12 13L8.75 9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.17886 19.248C1.84946 15.6186 1.94293 9.97559 5.45926 6.45926C9.07161 2.84691 14.9284 2.84691 18.5407 6.45926C22.0571 9.97559 22.1505 15.6186 18.8211 19.248" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLimit;
